import { RxCrossCircled } from "react-icons/rx";
import React, { useState } from "react";

const PopUpNewClient = ({ setClientPopUp, onSubmit, setNewClientActive, setOpenChatActive, clientId }) => {

    const [clientName, setClientName] = useState('');
    const [clientDescription,setClientDescription] = useState('');
    
    return (
        <div className='flex z-40 justify-center w-full lg:w-[30%] absolute bottom-2 lg:bottom-auto'>
            <div className='flex flex-col px-6 py-6 bg-white rounded-lg gap-3 absolute top-24 lg:left-[-10px] shadow-2xl'>
                
                <div id='header' className='flex justify-between'>
                    <div className="text-2xl font-medium text-black">Add new client </div>
                    <div onClick={() => {setNewClientActive(false); setClientPopUp(false); setOpenChatActive(!clientId)}} className='text-gray-300 hover:scale-105 cursor-pointer hover:text-red-500'>
                        <RxCrossCircled size={30} />
                    </div>
                </div>
                <div className="max-w-full mx-auto mt-2">
                <div>
                  <input
                    onChange={(e) => setClientName(e.target.value)}
                    className="w-full py-3 px-4 rounded-full border-[#D0D5DD] border bg-[#FCFCFC] focus:outline-[#B0B5BD]"
                    type="text"
                    placeholder="Full name"
                  />
                  <textarea
                    onChange={(e) => setClientDescription(e.target.value)}
                    className="w-full py-3 mt-4 px-4 rounded-2xl border-[#D0D5DD] border bg-[#FCFCFC] focus:outline-[#B0B5BD]"
                    placeholder="Enter a description of what your client is looking for."
                    rows={4}
                  />
                </div>
              </div>
                <div className='flex items-center'>
                    <button
                        onClick={() => onSubmit(clientName,clientDescription)}
                        type="button"
                        className='text-md py-3 rounded-full w-full flex justify-center items-center bg-[#0062FF] text-white transition-transform duration-300 hover:scale-105'
                    >
                        Create
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PopUpNewClient;
